import { render, staticRenderFns } from "./g-warning-modal.vue?vue&type=template&id=32616e92&scoped=true&"
import script from "./g-warning-modal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./g-warning-modal.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./g-warning-modal.vue?vue&type=style&index=0&id=32616e92&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32616e92",
  null
  
)

export default component.exports